/**
 * Type-safe wrapper around `window.dispatchEvent` for shell custom events.
 *
 * @example
 * dispatchGlobalShellEvent(GLOBAL_SHELL_EVENTS.ONBOARDING_STEPS_UPDATED);
 */
export function dispatchGlobalShellEvent(eventName) {
    if (typeof window === 'undefined')
        return;
    window.dispatchEvent(new CustomEvent(eventName, { bubbles: true }));
}
/**
 * Type-safe wrapper around `window.addEventListener` for shell custom events.
 * Returns a cleanup function that removes the listener — suitable for use in
 * `useEffect` or framework lifecycle hooks.
 *
 * @example
 * const unlisten = addGlobalShellEventListener(
 *   GLOBAL_SHELL_EVENTS.ONBOARDING_STEPS_UPDATED,
 *   () => refetch()
 * );
 * // later…
 * unlisten();
 */
export function addGlobalShellEventListener(eventName, handler) {
    if (typeof window === 'undefined')
        return function () { return undefined; };
    window.addEventListener(eventName, handler);
    return function () { return window.removeEventListener(eventName, handler); };
}
